/**
 * The one place the application's timezone is declared.
 *
 * Every stored date key in EAX FUEL is an Eastern calendar date, regardless of
 * where the device or the server is. Nothing else in the codebase may declare a
 * timezone, and nothing may read the machine zone
 * (`Intl.DateTimeFormat().resolvedOptions().timeZone`) to decide a calendar day.
 *
 * Audit references prevented here:
 *   constants.js #4  (APP_TZ declared twice, both copies live in one process)
 *   utils.js #4      (three date helpers duplicated inside server.js)
 *   integrations.js #3 (fmtISO used the browser zone and discarded the anchor)
 */

/** IANA zone the whole product operates in. */
export const APP_TZ = 'America/New_York';

/**
 * Label shown next to a wall clock time in the UI.
 *
 * Deliberately the generic "ET" rather than the seasonal EDT/EST abbreviation:
 * it is correct year round and does not change under a DST transition, so the
 * header does not flicker between two strings twice a year.
 */
export const APP_TZ_LABEL = 'ET';
